import { useState } from "react";

import { Button } from "../../components/Reusable/Button";
import { SearchIcon } from "../../assets/Icons";
import { ModalContainer } from "../../components/PageComponents";
import { CloseIcon } from "../../icons/promotions";
import { CreateCategoryModalProps, CategoryFormProps } from "./types";

export const CreateCategoryModal = ({
  isOpen,
  onClose,
  initialCategoryName = "",
  initialFields = [],
  onSubmit,
  isEditing = true,
}: CreateCategoryModalProps) => {
  const [categoryName, setCategoryName] = useState(initialCategoryName);
  const [fieldSearch, setFieldSearch] = useState("");
  const [fields, setFields] = useState<string[]>(initialFields);

  const handleAddField = () => {
    const trimmed = fieldSearch.trim();
    if (trimmed && !fields.includes(trimmed)) {
      setFields([...fields, trimmed]);
      setFieldSearch("");
    }
  };

  const handleRemoveField = (index: number) => {
    const updatedFields = [...fields];
    updatedFields.splice(index, 1);
    setFields(updatedFields);
  };

  const handleSubmit = () => {
    onSubmit(categoryName.trim(), fields);
    onClose(); // optionally close modal
  };

  //   const handleOverlayClick = (e: React.MouseEvent) => {
  //     if (e.target === e.currentTarget) {
  //       onClose();
  //     }
  //   };

  //   const handleModalClick = (e: React.MouseEvent) => {
  //     e.stopPropagation();
  //   };

  if (!isOpen) return null;
  return (
    // <div
    //   className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
    //   onClick={handleOverlayClick}
    // >
    //   <div
    //     className="bg-white dark:bg-[#1E1E1E] rounded-lg p-6 w-[660px] shadow-2xl"
    //     style={{
    //       boxShadow:
    //         "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    //     }}
    //     onClick={handleModalClick}
    //   >
    <ModalContainer
      title={isEditing ? "Edit Category" : "Create Category"}
      closeIcon={
        <button onClick={onClose}>
          <CloseIcon />
        </button>
      }
    >
      <CategoryForm
        categoryName={categoryName}
        setCategoryName={setCategoryName}
        fieldSearch={fieldSearch}
        setFieldSearch={setFieldSearch}
        fields={fields}
        handleAddField={handleAddField}
        handleRemoveField={handleRemoveField}
      />

      <div className="flex justify-end">
        <Button
          onClick={handleSubmit}
          className="mt-6 w-[168px] rounded-xl bg-gradient-to-r from-[#027EC2] to-[#039EF2] text-white"
        >
          {isEditing ? "Update Category" : "Create Category"}
        </Button>
      </div>
    </ModalContainer>

    //   </div>
    // </div>
  );
};

const CategoryForm = ({
  categoryName,
  setCategoryName,
  fieldSearch,
  setFieldSearch,
  fields,
  handleAddField,
  handleRemoveField,
}: CategoryFormProps) => {
  return (
    <div>
      <input
        type="text"
        placeholder="Category name"
        value={categoryName}
        onChange={(e) => setCategoryName(e.target.value)}
        className="w-full p-2 border rounded mb-4 bg-white dark:bg-[#FFFFFF1A] dark:border-[#FFFFFF1A]"
      />

      <div className="bg-[#F9FAFB]  dark:bg-[#FFFFFF1A] p-4 rounded mb-4">
        <h3 className="font-semibold mb-2 dark:text-white">Required Fields</h3>
        <div className="flex gap-2 items-center mb-4">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="Search for field"
              value={fieldSearch}
              onChange={(e) => setFieldSearch(e.target.value)}
              className="w-full p-2 border rounded bg-white dark:bg-[#FFFFFF1A] dark:border-[#FFFFFF1A] dark:text-white pl-10"
            />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <SearchIcon />
            </div>
          </div>
          <button
            onClick={handleAddField}
            className=" w-[100px] border border-[#D0D5DD] dark:border-[#FFFFFF1A] px-2 py-2 rounded-md text-sm dark:text-white dark:bg-[#FFFFFF1A]"
          >
            Add field
          </button>
        </div>

        <div className="border border-dashed border-[#D0D5DD] mt-6 mb-10"></div>

        <div className="flex flex-wrap gap-2 bg-white dark:bg-[#FFFFFF1A] p-4 rounded">
          {fields.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 bg-[#e5f1fa] text-sm px-3 py-1 rounded-full"
            >
              {item}
              <button
                className="ml-2 text-gray-600"
                onClick={() => handleRemoveField(idx)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
